import { useMemo } from 'react'
import { useSettings } from '../useSettings'

export type TimeDivisorSetting = {
    timeDivisor: number
    initialDuration: string
}

export function useTimeDivisorSetting(): TimeDivisorSetting {
    const settings = useSettings()

    const timeDivisor = useMemo<number>(() => {
        return settings?.timeDivisor
    }, [settings])

    const initialDuration = useMemo<string>(() => {
        if (!settings?.timeDivisor) {
            return '0:00'
        }
        return '0:' + `${settings.timeDivisor}`.padStart(2, '0')
    }, [settings])

    return { timeDivisor, initialDuration }
}
